import { useCallback, useRef } from "react";
import { debounce } from "lodash";

interface UseDebouncedCallbackProps {
  callback?: (args: any) => void;
  wait?: number;
  leading?: boolean;
  trailing?: boolean;
}

const useDebouncedCallback = ({
  callback,
  wait = 500,
  leading = false,
  trailing = false,
}: UseDebouncedCallbackProps) => {
  const debouncedFunctionRef = useRef<(args: any) => void>();
  debouncedFunctionRef.current = callback;
  return useCallback(
    debounce(
      (...args) => {
        // @ts-ignore
        debouncedFunctionRef.current?.(...args);
      },
      wait,
      { leading, trailing: trailing || !leading }
    ),
    []
  );
};
export default useDebouncedCallback;
